<p-toast position="top-right"></p-toast>
<p-confirmDialog #cdrg [style]="{width: '600px'}" key="rg-dialog">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cdrg.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cdrg.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div style="height:100%;display:flex;flex-direction:column;min-height:0;">
  <div style="height:36px" class="text-left">
    <button pButton pRipple label="Add Work Area" class="p-button-primary p-ml-3" icon="fas fa-warehouse" (click)="addOrUpdateWorkArea(null)"></button>
    
    <span class="text-small text-danger p-ml-3">
      Double click to edit work area.
      To delete a work area, you must make sure no employee was assigned to that work area, i.e., the employee count for the work area must be 0. 
    </span>
  </div>

  <div style="flex:1 1 auto;min-height:0; width:100%;">
    <ag-grid-angular
        *ngIf="workAreas.length > 0"
        style="width: 100%; height:100%;"
        class="ag-theme-alpine"
        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
        [gridOptions]="gridOptions"
        [context]="context"
        [rowData]="workAreas"
        [columnDefs]="gridHeaders"
        (rowDoubleClicked)='onRowDblClicked($event)' 
        (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>
</div>